import React from 'react';
import CarrosselImages from "../components/CarrosselImages";
import vaga1 from "../assets/imagesCarrossel/vaga1.jpeg";
import vaga2 from "../assets/imagesCarrossel/vaga2.jpeg";
import vaga3 from "../assets/imagesCarrossel/vaga3.jpeg";
import CardsHomeComponent from './CardsHomeComponent';
import Box from "@mui/material/Box";

import recrutamentoselecao from '../assets/imagesHome/recrutamentoselecao.jpeg';
import treinamentodesenvolvimento from '../assets/imagesHome/treinamentodesenvolvimento.png';
import gestaopessoas from '../assets/imagesHome/gestaopessoas.jpg';
import consultoriapersonalizada from '../assets/imagesHome/consultoriapersonalizada.jpg';

import Grid from '@mui/material/Grid';

export default function Home() {
  const imagens = [vaga1, vaga2, vaga3];

  const recrutamento = 
    "Com um processo ágil e estruturado, atraímos e avaliamos profissionais com o perfil técnico e comportamental ideal para o seu negócio.";

  const solucoes = 
    "Oferecemos uma gestão estruturada e estratégica das pessoas, desde a entrada até o desligamento. Aplicamos soluções como onboarding, organograma, cargos e salários, diagnósticos, clima, engajamento, qualidade de vida e performance, fortalecendo cultura, liderança e resultados.";

  const consultoria = 
    "Cada negócio é único e merece soluções exclusivas. Atuamos entendendo seus desafios, metas e estágio de maturidade para construir diagnósticos precisos, planos estratégicos e ações práticas que aprimoram cultura, governança e desempenho. Uma consultoria próxima, aplicada ao seu contexto e orientada a resultados concretos.";

  const treinamento = 
    "Potencializamos pessoas e líderes por meio de palestras, capacitações, mentorias e programas de comunicação assertiva. Nosso propósito é aprimorar competências, fortalecer cultura e impulsionar a performance das equipes, elevando ainda mais seu impacto e contribuindo para resultados sustentáveis.";

  return (
    <div className="row" style={{ justifyContent: "center" }}>
      
      <div className="col-12 mb-2">
        <CarrosselImages imagens={imagens} />
      </div>

      <Box 
        sx={{
          width: "100%",
          textAlign: "-webkit-center",
          display: {
            xs: "contents",
            sm: "contents",
            md: "inline-flex"
          },
          flexWrap: "wrap",
          justifyContent: "center",
          marginTop: "80px"
        }}
        className="row mb-4"
        >
        <div className="col-12 text-center mb-4">
          <h1 className='reconect-text'>PORTFÓLIO DE SERVIÇOS</h1>
        </div>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={6} md={3}>
            <CardsHomeComponent imagem={recrutamentoselecao} descricao={recrutamento} titulo="Recrutamento e Seleção" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <CardsHomeComponent imagem={gestaopessoas} descricao={solucoes} titulo="Soluções Integradas em Gestão de Pessoas" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <CardsHomeComponent imagem={consultoriapersonalizada} descricao={consultoria} titulo="Consultoria Personalizada" />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <CardsHomeComponent imagem={treinamentodesenvolvimento} descricao={treinamento} titulo="Treinamento e Desenvolvimento" />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
